module.exports = __webpack_public_path__ + "static/media/LK_File.937cab6d.svg";